"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var BaseXform = require('../base-xform');

var UnderlineXform =
/*#__PURE__*/
function (_BaseXform) {
  _inherits(UnderlineXform, _BaseXform);

  function UnderlineXform(model) {
    var _this;

    _classCallCheck(this, UnderlineXform);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UnderlineXform).call(this));
    _this.model = model;
    return _this;
  }

  _createClass(UnderlineXform, [{
    key: "render",
    value: function render(xmlStream, model) {
      model = model || this.model;

      if (model === true) {
        xmlStream.leafNode('u');
      } else {
        var attr = UnderlineXform.Attributes[model];

        if (attr) {
          xmlStream.leafNode('u', attr);
        }
      }
    }
  }, {
    key: "parseOpen",
    value: function parseOpen(node) {
      if (node.name === 'u') {
        this.model = node.attributes.val || true;
      }
    }
  }, {
    key: "parseText",
    value: function parseText() {}
  }, {
    key: "parseClose",
    value: function parseClose() {
      return false;
    }
  }, {
    key: "tag",
    get: function get() {
      return 'u';
    }
  }]);

  return UnderlineXform;
}(BaseXform);

UnderlineXform.Attributes = {
  single: {},
  "double": {
    val: 'double'
  },
  singleAccounting: {
    val: 'singleAccounting'
  },
  doubleAccounting: {
    val: 'doubleAccounting'
  }
};
module.exports = UnderlineXform;
//# sourceMappingURL=underline-xform.js.map



//////////////////
// WEBPACK FOOTER
// ./~/exceljs/dist/es5/xlsx/xform/style/underline-xform.js
// module id = 1503
// module chunks = 0